import { EventPublicStatus } from '../models/event';

const getToastText = (status: EventPublicStatus) => {
  if (status === EventPublicStatus.Ready) {
    return 'Aprobado';
  }
  if (status === EventPublicStatus.PendingApproval) {
    return 'Pendiente de aprobación';
  }
  if (status === EventPublicStatus.NoTicketsAvailable) {
    return 'Sin entradas disponibles';
  }
  if (status === EventPublicStatus.Expired) {
    return 'Finalizado';
  }
  if (status === EventPublicStatus.Inactive) {
    return 'Inactivo';
  }
  return '';
};

export default getToastText;
